import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEAgriculturalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Agricultural Engineering",
    shortName: "B.E. Agricultural",
    duration: "4 years",
    description: "Engineering program focused on mechanization and technology in agriculture and food production",
    overview: "Bachelor of Engineering in Agricultural Engineering (B.E. Agricultural) is a 4-year undergraduate program that applies engineering principles to agricultural production, processing, and rural development. This course covers farm machinery, irrigation systems, soil and water conservation, post-harvest technology, and rural infrastructure, preparing students for careers in agricultural mechanization and agribusiness.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Agriculture/Biology knowledge helpful",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Biology for Engineers",
          "Engineering Graphics",
          "Introduction to Agricultural Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Farm Power and Machinery",
          "Soil and Water Engineering",
          "Thermodynamics",
          "Fluid Mechanics",
          "Materials Science",
          "Agricultural Chemistry"
        ]
      },
      {
        year: 3,
        subjects: [
          "Irrigation and Drainage Engineering",
          "Post-Harvest Technology",
          "Farm Structures",
          "Renewable Energy in Agriculture",
          "Precision Agriculture",
          "Agricultural Processing"
        ]
      },
      {
        year: 4,
        subjects: [
          "Agricultural Automation",
          "Rural Development",
          "Agribusiness Management",
          "Environmental Impact in Agriculture",
          "Project Work",
          "Field Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Agricultural Engineer",
        "Farm Machinery Engineer",
        "Irrigation Engineer",
        "Agricultural Consultant",
        "Project Manager",
        "Research Officer",
        "Extension Officer",
        "Agricultural Equipment Sales Engineer",
        "Rural Development Officer",
        "Agribusiness Manager"
      ],
      industries: [
        "Agricultural Machinery Manufacturing",
        "Irrigation Equipment Companies",
        "Agricultural Consulting",
        "Government Agricultural Departments",
        "Research Institutions",
        "NGOs and Development Organizations",
        "Agribusiness Companies",
        "Farm Equipment Dealers",
        "Rural Development Projects",
        "International Agricultural Organizations"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "Mahindra Tractors, John Deere",
        "Jain Irrigation, Netafim",
        "NABARD, Agricultural Universities",
        "ICAR Research Institutes",
        "State Agricultural Departments",
        "NGOs like ICRISAT, IRRI"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Tamil Nadu Agricultural University",
        location: "Coimbatore",
        fees: "₹1,50,000",
        ranking: "Premier Agricultural University"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹2,00,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹4,00,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Farm Machinery Design",
      "Irrigation System Design",
      "Soil and Water Management",
      "AutoCAD and Design Software",
      "GPS and Precision Agriculture",
      "Project Management",
      "Agricultural Economics",
      "Rural Development",
      "Sustainable Agriculture",
      "Extension and Communication"
    ],

    futureScope: "Growing prospects with agricultural modernization, precision farming, sustainable agriculture practices, and government focus on doubling farmers' income.",

    faqs: [
      {
        question: "What career opportunities exist in Agricultural Engineering?",
        answer: "Opportunities include farm machinery development, irrigation projects, agricultural consulting, research institutions, and government agricultural departments."
      },
      {
        question: "Can I work with international organizations?",
        answer: "Yes, organizations like FAO, World Bank, CGIAR centers, and international NGOs working on agricultural development hire agricultural engineers."
      },
      {
        question: "Is this field suitable for rural development work?",
        answer: "Yes, agricultural engineering is excellent for rural development, working with farmers, implementing technology, and improving agricultural productivity."
      },
      {
        question: "What about research opportunities?",
        answer: "Excellent research opportunities in ICAR institutes, agricultural universities, and private companies developing agricultural technology and machinery."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEAgriculturalCoursePage;
